import { Component, OnInit, Injector, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { AuthService } from '../../shared/auth.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Message } from 'primeng//api';
import { environment } from '../../../environments/environment';
import { AutoLogoutService } from '../../utils/auto-logout.service';
import { LocalStorageService } from '../../shared/local-storage.service';
import { ThemeingService } from '../../utils/themeing.service';
import { PrivilegeService } from '../../shared/privilege.service';
import { MessageService } from 'primeng/api';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';

declare let snowplow: Function;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
  parentComponent: any;

  model: any = {};
  loading = false;
  sessionToken: any;
  isForgotPwd = false;
  captcha: any;
  logincaptcha: any;
  message: String = '';
  email: String = '';
  standPid: any;
  dataObj: any = {};
  stoken: any;
  selectpath: any;
  emailVerify = false;
  error = '';
  msgs: Message[] = [];
  resetPwd = false;
  confirmObj: any = {};
  pID: any;
  client = this.themeingService.getClientName();
  resetToken: any;
  logoURL = this.themeingService.getIcon('logoURL');
  @ViewChild('userName', { static: false }) private userName!: ElementRef;
  emailRegex: any = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
  passwordform: FormGroup = new FormGroup({});

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder,
    private location: Location,
    private injector: Injector,
    public privilegeService: PrivilegeService,
    private localStorage: LocalStorageService,
    private themeingService: ThemeingService,
    private messageService: MessageService) {
      // Query params will be handled in ngOnInit to avoid conflicts with OAuth callback detection
  }


  ngOnInit() {    
    // // Check for Microsoft OAuth callback parameters in window.location.search
    // const microsoftCallbackURLParams = new URLSearchParams(window.location.search);
    // const microsoftURLCode = microsoftCallbackURLParams.get('code');
    // const microsoftURLState = microsoftCallbackURLParams.get('state');
    // const microsoftURLError = microsoftCallbackURLParams.get('error');
    
    // // Check if we're at callback route with OAuth params (path-based routing)
    // const isAtRoot = this.router.url === '/' || this.router.url === '' || this.router.url === '/login';
    // const hasOAuthParams = (microsoftURLCode && microsoftURLState) || microsoftURLError;
    
    // // If we have OAuth params but are at root/login (shouldn't happen with path routing), redirect
    // if (hasOAuthParams && isAtRoot) {
    //   console.log('OAuth callback detected at root, processing callback directly...');
    //   this.processMicrosoftOAuthCallback(
    //     microsoftURLCode, microsoftURLState, microsoftURLError, microsoftCallbackURLParams
    //   );

    //   return;
    // }
    
    // // Standard route parameter checking
    // this.route.queryParams.subscribe(params => {      
    //   // Handle other query parameters
    //   console.log("Parsed query params:", params);
    //   if (params.resetToken) {
    //     this.showUpdatePwd(params);
    //     //this.router.navigate(['/login']);
    //   }
    // });
    
    this.parentComponent = this.injector.get(AutoLogoutService);
    this.recaptchaKey();
    if (this.isForgotPwd === false && this.resetPwd === false) {
      this.message = environment[window.location.hostname].defaultTitle;
    }
    
    if (this.authService.isLoggedIn()) {
      // Check if this is a temporary OAuth session - don't redirect if so
      const currentUser = this.authService.currentUser();
      if (currentUser) {
        this.router.navigate(['/dashboard']);
      }
    }

    if (this.parentComponent.showTimeoutMessage) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Your session has expired, Please login again.' });
      this.parentComponent.isSessionTimeOut = false;
      this.parentComponent.showTimeoutMessage = false;
    }
    this.createForm()
  }

  createForm(): void {
    this.passwordform = this.fb.group({
      'newPassword': new FormControl('', Validators.required),
      'password': new FormControl('', Validators.required),
    });
  }

  ngAfterViewInit() {
    // this.userName.nativeElement.focus();
  }

  recaptchaKey() {
    return environment[window.location.hostname].siteKey;
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
  }

  captchresolved(captchaResponse: string) {
    this.logincaptcha = captchaResponse;
  }

  showUpdatePwd(obj: any) {
    this.resetToken = obj['resetToken'];
    this.resetPwd = true;
    this.message = 'Change Password';
    this.createForm()
  }

  navigateToLogin() {
    this.isForgotPwd = false;
    this.message = environment[window.location.hostname].defaultTitle + ' ' + environment[window.location.hostname].envType;
  }

  loginClickHandler() {
    if (!this.model.username || !this.model.password) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Please enter valid Username and Password.' });
    } else if (!this.model.username || !this.model.password) return;
    else if (this.model.username && this.model.password) {
      this.login();
    }
  }

  login() {
    this.loading = true;
    if (!this.model.username) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Invalid credentials, Please try again' });
      this.loading = false;
      return;
    }
    this.authService.login(this.model.username.trim(), this.model.password).then((res) => {
      this.loading = false;
      this.msgs = [];
      if (res.status === "success") {
        res['roleCodes'][0] = atob(res['roleCodes'][0]);
        res['loginName'] = atob(res['loginName']);
        res['email'] = atob(res['email']);
        localStorage.setItem('currentUser', JSON.stringify(res));
        const currentUser = this.authService.currentUser();
        snowplow('setUserId', currentUser['_id']);
        if (!currentUser.resetPassword) {
          this.router.navigate(['/dashboard']);
          this.localStorage.initLocalStorageData();
          const sessionToken = currentUser['sessionToken'];
          // const sessionID = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase()
          snowplow('trackStructEvent', 'user_session', 'login', sessionToken, 'SESSION_TOKEN', sessionToken);
        } else if (currentUser.resetPassword) {
          this.router.navigate(['/resetpassword']);
        }
      } else {
        this.msgs = [];
        if (res.status === "ERR_AUTH_FAILLED") {
          this.msgs.push({ severity: 'error', summary: 'Invalid credentials, Please try again' });
        } else {
          this.msgs.push({ severity: 'error', summary: res.status })
        }
      }

    }).catch(err => {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Invalid credentials, Please try again' });
      this.loading = false;
      this.error = err;
    });
  }

  sendResetLink() {
    if (!this.emailRegex.test(this.email)) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: "Please enter valid email." });
      return;
    }
    if (!this.email || !this.captcha) return;
    const query: any = {};
    query['emailID'] = this.email;
    this.authService.forgotPassword(query).then(data => {
      if (data['status'] === 'success') {
        this.isForgotPwd = false;
        this.msgs = [];
        this.message = environment[window.location.hostname].defaultTitle + ' ' + environment[window.location.hostname].envType;
        this.messageService.add({ severity: 'success', detail: 'Link has been sent to the registered email' });
        return;
      } else if (data['status'] == "ERR_INVALID_LOGIN") {
        this.msgs = [];
        this.messageService.add({ severity: 'error', detail: "Please enter valid email."});
      } else if(data['status'] == "ERR_PASSWORD_RESET_LIMIT_EXCEEDED"){
        this.messageService.add({ severity: 'error', detail: 'Password reset limit has been exceeded. Please try after sometime.' });
      }
      else if (data['status'] == "USER BLOCKED - MAX RESET ATTEMPTS EXCEEDED") {
        console.log('blocked');
        this.msgs = [];
        this.messageService.add({ severity: 'error', detail: 'Maximun password reset limit has been exceeded.User blocked' });
      }
      else {
        this.messageService.add({ severity: 'error', detail: data['status'] });
      }
    }).catch(err => {
      this.msgs = [];
      this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
    });
  }

  keyDownFunction(event: any) {
    if (event.keyCode === 13) {
      this.loginClickHandler();
    }
  }

  forgotPassword() {
    this.email = '';
    this.msgs = [];
    this.isForgotPwd = true;
    this.message = 'Forgot Password';
    this.emailVerify = true;
  }

  reset() {
    if (!this.passwordform.controls['password'].valid || !this.passwordform.controls['newPassword'].valid) return;
    if (this.confirmObj.password && this.confirmObj.newPassword && this.confirmObj.password != this.confirmObj.newPassword) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Password mismatch' });
      return;
    }
    if (this.confirmObj.password && this.confirmObj.newPassword && this.confirmObj.password === this.confirmObj.newPassword) {
      const data = {
        'newPassword': window.btoa(this.confirmObj.newPassword),
        'resetToken': this.resetToken
      };
      this.resetPassword(data);
    }
  }

  resetPassword(data: any) {
    data.resetPassword = false;
    this.authService.updatePaswrd(data).then((res: any) => {
      this.msgs = [];
      switch (res['status']) {
        case 'success':
          this.msgs.push({ severity: 'success', summary: 'Password updated successfully' });
          this.resetPwd = false;
          this.message = environment[window.location.hostname].defaultTitle + ' ' + environment[window.location.hostname].envType;
          this.emailVerify = false;
          this.location.replaceState('login');
          break;
        case 'ERR_PWD_COMPLEXITY_ADMIN':
          this.msgs.push({ severity: 'error', summary: "Admin Password must be 15 characters including 1 uppercase letter, 1 lowercase letter and 1 numeric digit" });
          break;
        case 'ERR_PWD_COMPLEXITY_OPS':
          this.msgs.push({ severity: 'error', summary: "Operations Password must be 15 characters including 1 uppercase letter, 1 lowercase letter and 1 numeric digit" });
          break;
        case 'ERR_PWD_COMPLEXITY':
          this.msgs.push({ severity: 'error', summary: "Password must be 8 characters including 1 uppercase letter, 1 lowercase letter and 1 numeric digit" });
          break;
        case 'ERR_USER_NOT_FOUND': this.msgs.push({ severity: 'error', summary: "User not found" }); break;
        default: this.msgs.push({ severity: 'error', summary: res['status'] }); break;
      }
    }).catch(err => {
      this.msgs = [];
      this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
    });
  }

  // Perform immediate redirect without any delays
  // onMicrosoftSSOClick() {    
  //   this.loading = true;

  //   // Set up Microsoft OAuth parameters
  //   const clientId = environment[window.location.hostname].microsoftClientId;
  //   const tenantId = environment[window.location.hostname].microsoftTenantId;
  //   const redirectUri = encodeURIComponent(window.location.origin + '/login/microsoft/callback');
  //   const scope = encodeURIComponent('openid profile email User.Read');
  //   const responseType = 'code';
  //   const state = this.generateRandomState();

  //   // Use tenant-specific endpoint instead of /common
  //   const microsoftAuthUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?` +
  //     `client_id=${clientId}&` +
  //     `response_type=${responseType}&` +
  //     `redirect_uri=${redirectUri}&` +
  //     `scope=${scope}&` +
  //     `state=${state}&` +
  //     `response_mode=query`;
    
  //   // Store state in session storage for verification
  //   localStorage.setItem('microsoft_oauth_state', state);
  
  //   // Redirect to Microsoft OAuth authorization endpoint
  //   window.location.href = microsoftAuthUrl;
  // }

  // private generateRandomState(): string {
  //   return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  // }

  // // Process Microsoft OAuth callback directly without navigation
  // private processMicrosoftOAuthCallback(code: string, state: string, error: string, urlParams: URLSearchParams) {
  //   this.loading = true;

  //   // Verify state to prevent CSRF attacks
  //   const storedState = localStorage.getItem('microsoft_oauth_state');
  //   if (state && storedState && state !== storedState) {
  //     console.error('OAuth state mismatch - possible CSRF attack');
  //     this.handleOAuthError('State mismatch - security violation');
  //     return;
  //   }

  //   // Remove stored state
  //   localStorage.removeItem('microsoft_oauth_state');

  //   // Handle error responses from Microsoft
  //   if (error) {
  //     const errorDescription = urlParams.get('error_description') || 'Unknown OAuth error';
  //     console.error('Microsoft OAuth error:', error, errorDescription);
  //     this.handleOAuthError(`OAuth Error: ${error} - ${errorDescription}`);
  //     return;
  //   }

  //   // Handle successful authorization code
  //   if (code && state) {
  //     this.exchangeCodeForToken(code);
  //   } else {
  //     this.handleOAuthError('Invalid OAuth callback parameters');
  //   }
  // }

  // Exchange authorization code for access token
  // private exchangeCodeForToken(code: string) {
  //   this.loading = true;

  //   // Call backend microsoft login handling API
  //   this.authService.microsoftLogin(code).then((res) => {
  //     this.loading = false;
      
  //     if (res.status === "success") {
  //       // Decode the response data if needed
  //       res['roleCodes'][0] = atob(res['roleCodes'][0]);
  //       res['loginName'] = atob(res['loginName']);
  //       res['email'] = atob(res['email']);
        
  //       // Clear temporary OAuth session and set real user session
  //       localStorage.setItem('currentUser', JSON.stringify(res));
        
  //       const currentUser = this.authService.currentUser();
  //       snowplow('setUserId', currentUser['_id']);
        
  //       if (!currentUser.resetPassword) {
  //         // Navigate to dashboard
  //         this.router.navigate(['/dashboard']);
  //         this.localStorage.initLocalStorageData();
  //         const sessionToken = currentUser['sessionToken'];
  //         snowplow('trackStructEvent', 'user_session', 'login', sessionToken, 'SESSION_TOKEN', sessionToken);
  //       } else if (currentUser.resetPassword) {
  //         this.router.navigate(['/resetpassword']);
  //       }
  //     } else {
  //       // Handle API error response
  //       console.error('Microsoft login API error:', res.status);
  //       this.handleOAuthError(res.status);
  //     }
  //   }).catch((error) => {
  //     console.error('Microsoft login API call failed:', error);
  //     this.handleOAuthError(`Microsoft login API error: ${error.message || error}`);
  //   });
  // }

  // // Handle OAuth errors
  // private handleOAuthError(errorMessage: string) {
  //   this.loading = false;
  //   console.error('OAuth Error:', errorMessage);
    
  //   // Clear temporary OAuth session
  //   localStorage.removeItem('currentUser');
    
  //   // Show error message to user
  //   this.msgs = [];
  //   this.msgs.push({ 
  //     severity: 'error', 
  //     summary: 'Microsoft SSO Login Failed:', 
  //     detail: errorMessage 
  //   });
  // }
}
